var $$ajax = require('./ajax');

var $$config = require('config');


module.exports = {

    getMoreComment: function (uid, pageNo, pageSize, fn) {

        var _this = this;
        var data = {
            uid: uid || window.uid,
            pageNo: pageNo,
            pageSize: pageSize
        };


        $$ajax.get($$config.uDomain + '/api/v1/comment/project/list',
            data, fn);

    },
    replyUserDianping: function (commentId, comment, fn) {
        var _this = this;
        var data = {
            commentId: commentId,
            userDiscuss: comment

        };


        $$ajax.post($$config.uDomain + '/api/v1/comment/project/reply',
            data, fn);

    }
};



// WEBPACK FOOTER //
// ./src/model/comment.js